document.addEventListener('DOMContentLoaded', function() {
  const items = document.querySelectorAll('.faq-accordion__item');

  items.forEach(item => {
    const trigger = item.querySelector('.faq-accordion__item-title');
    const content = item.querySelector('.faq-accordion__item-description');

    content.style.height = '0px';
    content.style.overflow = 'hidden';
    content.style.paddingBottom = '0px';

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      items.forEach(otherItem => {
        const otherContent = otherItem.querySelector('.faq-accordion__item-description');
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');
          otherContent.style.height = '0px';
          otherContent.style.paddingBottom = '0px';
        }
      });

      if (isOpen) {
        content.style.height = '0px';
        content.style.paddingBottom = '0px';
        item.classList.remove('is-open');
      } else {
        item.classList.add('is-open');

        content.style.height = 'auto';
        const fullHeight = content.scrollHeight + 'px';
        content.style.height = '0px';

        requestAnimationFrame(() => {
          content.style.height = fullHeight;
          content.style.paddingBottom = '20px';
        });
      }
    });
  });
});
